import React from "react";
import Box from "@mui/material/Box";

// `trailing` (e.g. a chevron on a row that opens something) sits outside the
// stacking column, so it stays centred against the row's full height instead of
// dropping onto a line of its own on a phone.
function RowShell({ children, onClick, stack, trailing }) {
  const body = (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        // A row carrying an action button has too little width left for its text
        // column on a phone, so `stack` drops the actions onto their own line.
        flexDirection: stack ? { xs: "column", sm: "row" } : "row",
        alignItems: stack ? { xs: "stretch", sm: "center" } : "center",
        gap: stack ? { xs: 1.25, sm: 2 } : 2,
        ...(trailing && { flex: 1, minWidth: 0 })
      }}
    >
      {children}
    </Box>
  );

  return (
    <Box
      onClick={onClick}
      sx={{
        py: 1.5,
        borderBottom: 1,
        borderColor: "divider",
        "&:last-child": { borderBottom: 0 },
        ...(onClick && {
          cursor: "pointer",
          transition: "background-color 120ms ease",
          mx: -2,
          px: 2,
          borderRadius: 1,
          "&:hover": { backgroundColor: "action.hover" }
        })
      }}
    >
      {trailing ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {body}
          {trailing}
        </Box>
      ) : (
        body
      )}
    </Box>
  );
}

export default RowShell;
